/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Sidebar } from "syngenta-digital-cropwise-react-ui-kit";
import { trackSidebarItemClicked } from "shared/utils/analyticsEvents";
import { withWorkspaceId } from "shared/utils/workspaceRouting";
import "./sidebar.less";
interface Route {
  name: string;
  path: string;
}

interface SidebarMenuProps {
  currentHallOfEntitiesPathName?: string;
}

export const SidebarMenu: React.FC<SidebarMenuProps> = ({
  currentHallOfEntitiesPathName,
}) => {
  const navigate = useNavigate();
  const currentPath = useLocation().pathname.split("/");
  const isAssessment = currentPath.toString().includes("assessment")
    ? "ASSESSMENTS"
    : "";
  const [active, setActive] = useState(isAssessment);
  const currentPage = currentPath.at(currentPath.length - 1) ?? "";
  const isMyCropwiseRoute = currentPath[1] === "my-cropwise";
  const isOrganizationRoute = currentPath.includes("organization");
  const routes: Record<string, Route> = {};

  if (
    isMyCropwiseRoute ||
    currentHallOfEntitiesPathName?.includes("workspace") ||
    currentHallOfEntitiesPathName?.includes("assessments") ||
    isOrganizationRoute
  ) {
    routes.MYCROPWISE = {
      name: "My Cropwise",
      path: "/",
    };
  }

  if (isOrganizationRoute) {
    routes.ASSESSMENTS = {
      name: "Assessments",
      path: "/assessments",
    };
  }
  const routesMap = Object.keys(routes);
  return (
    <Sidebar
      data-cy="sidebar"
      theme="dark"
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      selectedKeys={[
        active ||
          (isMyCropwiseRoute ? "MYCROPWISE" : currentPage.toUpperCase()),
      ]}
      collapsedMenu={true}
      items={routesMap.map((route) => ({
        key: route,
        label: routes[route].name,
        icon: (
          <img
            className="sidebar-icon active"
            alt={route.toLowerCase()}
            src={require(`../../assets/images/${route
              .toLowerCase()
              .replaceAll("_", "-")}.svg`)}
          />
        ),
        onClick: async (e: any) => {
          setActive(route);
          trackSidebarItemClicked(routes[route].name);
          navigate(
            route === "MYCROPWISE"
              ? "/my-cropwise"
              : withWorkspaceId(`/app${routes[route].path}`)
          );
        },
      }))}
    />
  );
};
